import { FC } from "react";

import { PageLimitProps, filterOutPagesInOtherSections, usePageLimits } from "./helper";
import { PagesCard } from "./topic/activity/detail/PagesCard";

import { t } from "i18n/i18n";
import { Card } from "mds/components/Card";
import { useHomeRole } from "providers/HomeRoleProvider";
import { activitySelectors, selectAllRecentlyAssessedPages } from "store/selectors";
import { useListSelector } from "store/store-hooks";
import { useViewLevel } from "utils/urls";

type RecentlyAssessedPagesListProps = PageLimitProps & {
  shouldLinkSidebar?: boolean;
};

// On home, filter by home persona across sections; otherwise current section.
export const RecentlyAssessedPagesList: FC<RecentlyAssessedPagesListProps> = ({
  showAll,
  onCountChanged,
  shouldLinkSidebar,
}) => {
  const activities = useListSelector(activitySelectors.filterForCurrentSection);
  const isHome = useViewLevel().home === true;
  const homeRole = useHomeRole();

  const recentlyAssessedPagesInTheLastSevenDays = useListSelector((s) =>
    selectAllRecentlyAssessedPages(s, 7, homeRole),
  );

  const displayPages = usePageLimits(
    filterOutPagesInOtherSections(recentlyAssessedPagesInTheLastSevenDays),
    showAll,
    onCountChanged,
  );

  const header = t(`section.sidebar.planner.recently_assessed`);

  if (!displayPages.length) {
    return (
      <>
        <div className="body-s m-2 text-black-tint-40">{header}</div>
        <Card className="mb-3" small>
          <div className="body-s p-2 font-light text-black-tint-40">
            {t("section.sidebar.planner.no_pages_recently_assessed")}
          </div>
        </Card>
      </>
    );
  }

  return (
    <PagesCard
      activities={activities}
      header={header}
      pages={displayPages}
      shouldLinkSidebar={shouldLinkSidebar}
      showSectionTitle={isHome}
    />
  );
};
